// AlertRBDBannerVerified.jsx
import * as React from "react";
import {
  Box,
  Typography,
  Link,
  Paper,
  Divider,
  IconButton,
  Collapse,
} from "@mui/material";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

function storageKey(rbd) {
  return `sagec:rbd:${rbd}:banner:direccion_verificada:closed`;
}

export default function AlertRBDBannerVerified({
  rbd,
  direccion = "-",
}) {
  const navigate = useNavigate();
  const key = React.useMemo(() => storageKey(rbd), [rbd]);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const closed = localStorage.getItem(key) === "1";
    setOpen(!closed);
  }, [key]);

  const handleClose = () => {
    localStorage.setItem(key, "1");
    setOpen(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    navigate(`/establecimiento_modificar/${rbd}`);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  if (!rbd) return null;

  return (
    <Collapse in={open} timeout={200} unmountOnExit>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3, // mismo estilo que el original
          overflow: "hidden",
          width: "100%",
        }}
      >
        {/* Barra superior */}
        <Box
          sx={{
            position: "relative",
            backgroundColor: "#CBE8CE",
            py: 1.2,
            px: 2,
            textAlign: "center",
            fontWeight: 400,
            fontSize: "1.05rem",
          }}
        >
          Representante RBD {rbd}

          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Divider sx={{ borderColor: "white" }} />

        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            p: 2,
            backgroundColor: "#CFEAD1",
          }}
        >
          <Box
            sx={{
              border: "2px solid #CFEAD1",
              borderRadius: "50%",
              p: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <VerifiedOutlinedIcon sx={{ fontSize: 48, color: "#4CAF50" }} />
          </Box>

          <Box>
            <Typography
              variant="h3"
              sx={{ fontWeight: 700, mb: 0.5, lineHeight: 1.2 }}
            >
              Dirección verificada
            </Typography>

            <Typography variant="body2" sx={{ py: 1 }}>
              MINEDUC ha validado exitosamente la dirección ‘{direccion}’, lo
              invitamos a mantener siempre al día la verificación de los datos
              de su establecimiento, de haber algún cambio en la dirección por
              favor volver a dirigirse a{" "}
              <Link
                component="button"
                onClick={handleClick}
                sx={{
                  fontWeight: 700,
                  textDecoration: "underline",
                  textUnderlineOffset: "2px",
                  color: "inherit",
                }}
              >
                Editar datos del establecimiento
              </Link>{" "}
              para su actualización.
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Collapse>
  );
}